import React, { useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import styles from "./Testimonials.module.css";
import { Star, Starfill , leftnav , rightNav} from "../../controller/Images";

const _items = [
  {
    profile: {
      name: "Tamilarasu Rajendran",
      role: "Frontend Developer",
      company: "CodeSpark",
      text: `Using this UI Kit has completely changed the way I build landing pages. It's clean, responsive, and super easy to tweak to my needs. Honestly, a huge time changed the way I build landing pages. It's clean, responsive, and super easy to tweak to my needs. Honestly, a huge time saver!changed the way I build landing pages. It's clean, responsive, and super easy to tweak to my needs. Honestly, a huge time saver! saver!`,
      image: "https://i.postimg.cc/RhYnBf5m/er-slider.jpg",
      rating: 1,
    },
  },
  {
    profile: {
      name: "Liam K.",
      role: "Product Designer",
      company: "DesignLab",
      text: `The component variety and quality are top-notch. It saved me tons of time and looks super polished in every project!`,
      image: "https://i.postimg.cc/qBGQNc37/ro-slider.jpg",
      rating: 2,
    },
  },
  {
    profile: {
      name: "Sophia M.",
      role: "UI/UX Researcher",
      company: "UserFlow",
      text: `I love how intuitive everything feels. The design system just works and makes collaboration with developers a breeze.`,
      image: "https://i.postimg.cc/cHdMJQKG/svb-slider.jpg",
      rating: 3,
    },
  },
  {
    profile: {
      name: "Ethan P.",
      role: "Full Stack Engineer",
      company: "TechHive",
      text: `Perfect for rapid prototyping. All the components are customizable, and the code is super clean and maintainable.`,
      image: "https://i.postimg.cc/C12h7nZn/ms-1.jpg",
      rating: 4,
    },
  },
  {
    profile: {
      name: "Isabella T.",
      role: "Marketing Strategist",
      company: "BrightBuzz",
      text: `We've used this kit for multiple client projects, and it's always impressed. Sleek visuals and easy integrations!`,
      image: "https://i.postimg.cc/NfzMDVHP/willie-mosconi-slider.jpg",
      rating: 5,
    },
  },
];

const length = _items.length;
_items.push(..._items);

const sleep = (ms = 0) => new Promise((resolve) => setTimeout(resolve, ms));

const createItem = (position, idx) => {
  const item = {
    styles: {
      transition: "all 0.5s ease",
    },
    profile: _items[idx].profile,
    isActive: position === length,
  };

  const isMobile = window.innerWidth <= 768;

  if (position === length) {
    item.styles.left = "50%";
    item.styles.transform = "translateX(-50%) scale(1)";
    item.styles.zIndex = 3;
    item.styles.opacity = 1;
  }

  // Left inactive card
  else if (position === length - 1) {
    item.styles.left = isMobile ? "41%" : "38%";
    item.styles.transform = "translateX(-50%) scale(0.8)";
    item.styles.zIndex = 2;
    item.styles.opacity = 0.7;
  }

  // Right inactive card
  else if (position === length + 1) {
    item.styles.left = isMobile ? "59%" : "62%";
    item.styles.transform = "translateX(-50%) scale(0.8)";
    item.styles.zIndex = 2;
    item.styles.opacity = 0.7;
  }

  // All other cards
  else {
    item.styles.opacity = 0;
    item.styles.pointerEvents = "none";
    item.styles.zIndex = 1;
  }

  return item;
};

const CarouselSlideItem = ({
  pos,
  idx,
  activeIdx,
  windowWidth,
  onMouseEnter,
  onMouseLeave,
  setIsHovered,
  onTouchStart,
  onTouchEnd,
}) => {
  const item = createItem(
    pos,
    idx,
    activeIdx,
    windowWidth,
    onMouseEnter,
    onMouseLeave,
    onTouchStart,
    onTouchEnd
  );
  return (
    <>
      <li
        className={`${styles.carousel__slide_item} ${
          item.isActive ? styles.activeCard : styles.inactiveCard
        }`}
        style={item.styles}
        onMouseEnter={item.isActive ? onMouseEnter : undefined}
        onMouseLeave={item.isActive ? onMouseLeave : undefined}
        onTouchStart={item.isActive ? onTouchStart : undefined}
        onTouchEnd={item.isActive ? onTouchEnd : undefined}
      >
        <div className={`card border-0 ${styles.Card_container}`}>
          <div className={`card-body  ${styles.Body_Card}`}>
            <div className={`${styles.Card_Section}`}>
              {/* Profile Image */}
              <div className="col-12 col-md-4 ">
                <div className="text-center">
                  <img
                    src={item.profile.image}
                    alt={item.profile.name}
                    className={`rounded-circle ${styles.image}`}
                    // style={{ width: "80px", height: "80px", objectFit: "cover" }}
                  />
                  <h5 className={`mb-1 fw-semibold pt-2 ${styles.name} main_paragraph`}>
                    {item.profile.name}
                  </h5>
                  <p className={`m-0 p-0 ${styles.role} main_paragraph`}>
                    {item.profile.role}
                  </p>
                  <p className={`m-0 p-0 text-dark ${styles.company} main_paragraph`}>
                    {item.profile.company}
                  </p>
                </div>
              </div>

              {/* Name and Role/Company Info */}
              <div className=" col-12 col-md-8">
                <span>
                  <div className={`d-flex px-1 ${styles.Card_content}`}>
                    {[...Array(5)].map((_, i) => (
                      <div key={i} className={styles.star}>
                        <img
                          src={i < item.profile.rating ? Starfill : Star}
                          alt={
                            i < item.profile.rating
                              ? "Filled star"
                              : "Empty star"
                          }
                          width="30"
                          height="30"
                        />
                      </div>
                    ))}
                  </div>
                  <p className={`m-0 py-2 ${styles.card_text} main_paragraph`}>
                    {item.profile.text}
                  </p>
                </span>
              </div>
            </div>
          </div>
        </div>
      </li>
    </>
  );
};

const Carousel = () => {
  const [items, setItems] = useState(Array.from(Array(_items.length).keys()));
  const [isTicking, setIsTicking] = useState(false);
  const [activeIdx] = useState(0);
  const bigLength = items.length;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isHovered, setIsHovered] = useState(false);
  // const [touchedButton, setTouchedButton] = useState(null);

  const prevClick = (jump = 1) => {
    if (!isTicking) {
      setIsTicking(true);
      setItems((prev) => prev.map((_, i) => prev[(i + jump) % bigLength]));
    }
  };

  const nextClick = (jump = 1) => {
    if (!isTicking) {
      setIsTicking(true);
      setItems((prev) =>
        prev.map((_, i) => prev[(i - jump + bigLength) % bigLength])
      );
    }
  };

  // const handleTouch = (button) => {
  //   setTouchedButton(button);
  //   setTimeout(() => {
  //     setTouchedButton(null);
  //   }, 2000);
  // };

  useEffect(() => {
    if (isTicking) {
      sleep(500).then(() => setIsTicking(false));
    }
  }, [isTicking]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isHovered && !isTicking) {
        nextClick();
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [isHovered]); // Removed isTicking dependency

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className={`${styles.carousel_main}`}>
      <div className="text-center pt-5">
        <h5 className={` main_heading ${styles.section_heading}`}>
          Client Success Stories
        </h5>
        <h5 className={`m-0 main_subheading ${styles.section_subtext}`}>
          Our clients consistently trust and value our work
        </h5>
      </div>
      <div className={`${styles.carousel__wrap}`}>
        <div className={`${styles.carousel__inner}`}>
          <button
            onClick={() => prevClick()}
            className={` ${styles.navBtn} ${styles.leftBtn}`}
          >
            <img
              src={leftnav}
              alt="Previous"
              style={{ width: "24px", height: "24px" }}
            />
          </button>

          <div
            className={`${styles.carousel__container}`}
            //  onMouseEnter={() => setIsHovered(true)}
            //  onMouseLeave={() => setIsHovered(false)}
          >
            <ul className={`${styles.carousel__slide_list}`}>
              {items.map((pos, i) => (
                <CarouselSlideItem
                  key={i}
                  idx={i}
                  pos={pos}
                  activeIdx={activeIdx}
                  windowWidth={windowWidth}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  onTouchStart={() => setIsHovered(true)}
                  onTouchEnd={() => setIsHovered(false)}
                />
              ))}
            </ul>
          </div>
          <button
            onClick={() => nextClick()}
            // onTouchStart={() => setIsHovered(true)}
            // onTouchEnd={() => setIsHovered(false)}
            // onTouchStart={() => handleTouch("right")}
            className={`${styles.navBtn} ${styles.rightBtn}`}
            // style={{ fontSize: "24px" }}
          >
           <img
              src={rightNav}
              alt="Previous"
              style={{ width: "24px", height: "24px" }}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Carousel;
